"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleAction = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../../../dsl/front");
const Screen_1 = require("../../Screen");
/**
 * @author Sebastian Dziechciarz, Stanisław Gregor
 */
let ArticleAction = class ArticleAction extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        /**
         * Determine if action is in progress.
         */
        this.isLoading = false;
    }
    /**
     * Determines whether there is any icon to render.
     */
    get hasIcon() {
        return typeof this.icon === 'string' && this.icon.length > 0;
    }
    /**
     * Determines whether there is any label to render.
     */
    get hasLabel() {
        return typeof this.label === 'string' && this.label.length > 0;
    }
    performAction() {
        const callbackReturn = this.callback();
        if (callbackReturn && typeof callbackReturn.then === 'function') {
            this.isLoading = true;
            callbackReturn.finally(() => {
                this.isLoading = false;
            });
        }
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Function, required: true }),
    __metadata("design:type", Function)
], ArticleAction.prototype, "callback", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], ArticleAction.prototype, "disabled", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false }),
    __metadata("design:type", Object)
], ArticleAction.prototype, "icon", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false }),
    __metadata("design:type", Object)
], ArticleAction.prototype, "label", void 0);
ArticleAction = __decorate([
    vue_property_decorator_1.Component({
        name: 'ArticleAction',
        components: { BootstrapButton: front_1.BootstrapButton, BootstrapIcon: front_1.BootstrapIcon, Screen: Screen_1.Screen },
        template: `
    <Screen :loading="isLoading">
      <BootstrapButton class="article-action btn-link p-0" @click="performAction" v-bind="{ disabled }">
        <BootstrapIcon v-if="hasIcon" :name="icon" size="small"
                 class="article-action__icon me-1" />
        <span v-if="hasLabel" class="text-ui-separator-link">
          {{ label }}
        </span>
      </BootstrapButton>
    </Screen>
  `
    })
], ArticleAction);
exports.ArticleAction = ArticleAction;
exports.default = ArticleAction;
//# sourceMappingURL=ArticleAction.js.map